import api from "../assets/js/service/api";
import jsonpUtil from "./jsonpUtil";
import request from "./request";
const ISJSON = true;
//获取用户登录状态  登录任意产品即为登录
export function getUserLoginStatus() {
  return jsonpUtil.jsonp(api.jsonp.userLoginStatus, {});
}
// 获取用户信息
export function getUserInfo(params) {
  return request.get(api.auth.userInfo, params);
}
//获取用户是否可进入网校通的状态
export function getUserRoleInfoStatus() {
  return request.get(api.auth.userRoleStatus);
}
// 权益中心获取用户信息
export function getUserinfoRights() {
  return request.get(api.rights.userinfoRights);
}
// replace(/(http|https):/g, "")
export const LOGINURL =
  `//${window.location.host}/wxtapi/auth/login?curl=` +
  encodeURIComponent(window.location.href || `https://${window.location.host}`);
export const DEFAULTSCHOOLLOGO = `https://zxxkstatic.zxxk.com/mingxiao/skins/img/more-mx-bg.png`;
export const beikeHost =
  window.location.host.indexOf("test-wxt") > -1
    ? "test-beike.xkw.com"
    : window.location.host.indexOf("pre-wxt") > -1
    ? "pre-beike.xkw.com"
    : "beike.xkw.com";
export const protocolName =
  window.location.host.indexOf("test-wxt") > -1 ? "tsso" : "sso";
export const wxtHost =
  window.location.host.indexOf("test-wxt") > -1
    ? "https://test-wxt.xkw.com"
    : "https://wxt.xkw.com";
// 获取用户模块列表
export function getUserMode(params) {
  return request.get(api.work.modules, params);
}
// 获取系统模块
export function getSystemModules(params) {
  return request.get(api.modules.getSystemModules, params);
}
// 获取更多应用
export function getUserMoreApp() {
  return request.get(api.modules.getUserMoreApp);
}
// 获取用户教材
export function getUserBooks() {
  return request.get(api.work.textbooks);
}
// 获取用户收藏
export function getUserFavorite(params) {
  return request.get(api.work.favorites, params);
}
// 获取用户下载
export function getUserDownload(params) {
  return request.get(api.work.downloads, params);
}
// 获取试题类别
export function getResourceCategories() {
  return request.get(api.nav.categories);
}
export function getResourceCategoriesV4(params) {
  return request.get(api.nav.categoriesV4, params);
}
// 获取资料场景
export function getResourceTypes(params) {
  return request.get(api.nav.types, params);
}
// 获取【同步素材】筛选项列表
export function getMaterialTypes(params) {
  return request.get(api.nav.materialTypes, params);
}
// 获取素材场景
// 获取试题范围
export function getResourceRanges(params) {
  return request.get(api.nav.range, params);
}
// 获取商业等级筛选
export function getCommercialClasses(params) {
  return request.get(api.nav.classes, params);
}

// 获取资源库备考页面url
export function getZykExamUrl(params) {
  return request.postJson(api.nav.zyk, params);
}

// 获取上好课备考页面 url
export function getShkExamUrl(params) {
  return request.postJson(api.nav.shk, params);
}

// 获取地区
export function getAreas(params) {
  return request.get(api.base.areas, params);
}
export function getAreasFZ(params) {
  return request.get(api.base.areasFZ, params);
}
// 获取学校和机构列表
export function getOrganizations(params) {
  return request.get(api.base.getOrganizationsByConditions, params);
}
// 获取组织列表
export function getIntroduceOrganizations(params) {
  return request.postJson(api.base.organizations, params);
}
// 获取年份
export function getYears() {
  return request.get(api.nav.years);
}
export function getYearsFZ() {
  return request.get(api.nav.yearsFZ);
}
// 获取教材目录
export function getCatalog(params, cancelToken) {
  return request.get(api.nav.catalog, params, cancelToken);
}
// 获取资料列表
export function getDocumentList(params) {
  return request.get(api.document.documents, params);
}
// 获取实操实验资料列表
export function getLhsDocumentList(params) {
  return request.get(api.document.lhsDocumentList, params);
}
// 获取文档类型
export function getDocumentTypes() {
  return request.get(api.nav.fileTypes);
}
// 获取学科特色列表
export function getSubjectCharacteristics(params) {
  return request.get(api.nav.subjectCharacteristics, params);
}
// 获取下载地址
export function getSoftDownloadurl(params) {
  return request.get(api.download.url, params);
}
// 轮询下载
export function getTraningDownloadurl(params) {
  return request.post(api.download.training, params);
}
// 取消收藏
export function cancelCollection(params) {
  return request.post(api.work.cancelFavorite, params, ISJSON);
}
// 获取用户卡片
export function getUserCards(params) {
  return request.get(api.work.cards, params);
}
// 获取用户功能模块
export function getUserFunctions(params) {
  // console.log("params", params);
  return request.get(api.work.functions, params);
}
// 根据学段获取学科列表
export function getSubjects(params) {
  return request.get(api.base.subjects, params);
}
// 获取学段与学科列表
export function getStages() {
  return request.get(api.base.stages);
}
export function getScsyStageAndSubjectList() {
  return request.get(api.base.experimentStageAndSubjectList);
}
// 获取同步课程列表
export function getSyncCourseList() {
  return request.get(api.sync.getCourseList);
}
// 获取同步版本列表
export function getSyncVersionList(params) {
  return request.get(api.sync.getVersionList, params);
}
export function getSyncTeachCatalogs(params) {
  return request.post(api.sync.syncTeachCatalogs, params);
}
export function getExamTeachCatalogs(params) {
  return request.get(api.exam.examTeachCatalogs, params);
}
export function getExamCourseRecommendList(params) {
  return request.get(api.exam.getCourseRecommendList, params);
}
// 获取备考下的父节点数据
export function getExamChildDocuments(params) {
  return request.postJson(api.exam.getTreeChildList, params);
}

// 获取备考栏目资料列表
export function getExamCategoryList(params, cancelToken = false) {
  return request.postJson(api.exam.getCategoryList, params, cancelToken);
}
// 获取备考栏目列表
export function getExamTeachMenus(params) {
  return request.postJson(api.exam.getExamTeachMenus, params);
}

// 课程推荐资料列表
export function getCourseRecommendList(params) {
  return request.get(api.sync.getCourseRecommendList, params);
}
// 获取实验类型列表
export function getExperimentCategoryList(params) {
  return request.get(api.base.experimentCategoryList, params);
}
// 获取版本列表
export function getVersions(params) {
  return request.get(api.base.versions, params);
}
// 获取更新日志
export function getSysUpdateLogs() {
  return request.get(api.system.getSysUpdateLogs);
}
// 获取册别列表
export function getTextbooks(params) {
  return request.get(api.base.textbooks, params);
}
// 添加教材
export function addTextbook(params) {
  return request.postJson(api.work.addTextbook, params);
}
// 获取试题试卷下的特殊类型
export function getOptions(params) {
  return request.get(api.nav.option, params);
}
// 获取用户课程
export function getUserCourses() {
  return request.get(api.work.getCourse);
}
// 获取用户课程（含教材）
export async function getUserCoursesBooks() {
  return request.get(api.work.getCourseBook);
}
export async function getUserReviewCourseBooks() {
  return request.get(api.schoolbase.review.reviewCourseList);
}
// 添加用户课程
export function addCourse(params) {
  return request.post(api.work.addCourse, params);
}

// 获取备考列表目录
export function getExamsCatalog(params) {
  return request.get(api.nav.examsCatalog, params);
}
// 获取校本备考目录列表
export function getExamsAndCharacterCatalogs(params) {
  return request.get(api.nav.examsAndCharacterCatalogs, params);
}
// 获取备考列表目录V4
export function getExamsCatalogV4(params) {
  return request.get(api.nav.examsCatalogV4, params);
}
// 获取升学备考列表目录
export function getReviewCatalog(params) {
  return request.get(api.nav.reviewCatalog, params);
}
// 获取升学备考列表目录V4
export function getReviewCatalogV4(params) {
  return request.get(api.nav.reviewCatalogV4, params);
}
export function getReviewCatalogSchoolV4(params) {
  return request.get(api.nav.reviewCatalogSchoolV4, params);
}
// 获取知识点列表目录
export function getKnowledgeCatalog(params) {
  return request.get(api.nav.knowledgeCatalog, params);
}
// 获取实操实验目录树
export function getScsyCatalog(params) {
  return request.post(api.base.scsyCatalog, params);
}
// 获取年级
export function getGrades(params) {
  return request.get(api.base.grades, params);
}
// 获取学期
export function getTerms() {
  return request.get(api.base.terms);
}
// 获取学年
export function getYearRange(params) {
  return request.get(api.base.yearrange, params);
}
// 用户功能
export function getFeatures(params) {
  return request.get(api.work.functions, params);
}
// 偏好设置
export function setFeatures(params) {
  return request.post(api.work.setFeatures, params, ISJSON);
}
// 删除教材
export function deleteBook(params) {
  return request.post(api.work.deleteBook, params);
}

// 获取校本资料列表
export function getSchoolBasedList(params) {
  return request.post(api.schoolbase.schoolbasedocuments, params, ISJSON);
}
// 获取用户下载
export function getSchoolBasedUserDownload(params) {
  return request.get(api.schoolbase.downloads, params);
}
// 获取专辑列表
export function getAlbumList(params) {
  return request.post(api.document.albums, params, ISJSON);
}
// 获取相关推荐数据
export function getListAlbumRecommend(params) {
  return request.postJson(api.document.listAlbumRecommend, params);
}
// 获取编辑推荐数据
export function getListEditorRecommend(params) {
  return request.get(api.document.listEditorRecommend, params);
}
// 获取专辑更新状态
export function getUpdateStatus() {
  return request.get(api.nav.updateStatus);
}
// 获取资源审核状态
export function getReviewStatus() {
  return request.post(api.schoolbase.review.reviewStatusList);
}
// 获取专辑的学校级别
export function getSchoolLevels() {
  return request.get(api.nav.schoolLevel);
}
// 获取课程详情
export function getCourseDetail(params) {
  return request.get(api.base.course, params);
}
// 获取学校信息
export function getSchoolInfo(params) {
  return request.get(api.base.schoolInfo, params);
}
// 获取教材详情
export function getTextbookDetail(params) {
  return request.get(api.base.textbook, params);
}
//获取学校统计数据概览
export function getSchoolStatistics(params) {
  return request.post(api.schoolbase.schoolstatistics, params, true);
}
//获取学科统计数据概览
export function getSubjectStatistics(params) {
  return request.post(api.schoolbase.subjectstatistics, params, true);
}
//获取教师统计数据概览
export function getTeacherStatistics(params) {
  return request.post(api.schoolbase.teacherstatistics, params, true);
}
// 获取学段
export function getBasicStage() {
  return request.get(api.base.basicStage);
}
// 获取学校学段
export function getSchoolStages(isWithWxt = false) {
  return request.get(
    isWithWxt ? api.base.schoolAndAuthStageList : api.base.schoolStages
  );
}
// 获取课后服务分类
export function getAfterTypeList(params) {
  return request.post(api.afterService.afterTypeList, params, ISJSON);
}
// 获取课后专辑列表
export function getAfterAlbumList(params) {
  return request.post(api.afterService.afterAlbumList, params, ISJSON);
}
// 获取专辑详细
export function getAlbumDetail(params) {
  return request.get(api.afterService.getAlbumDetail, params);
}
// 获取我的备考
export function getMyBkList(params) {
  return request.get(api.work.getUserLatestFilesBk, params);
}
// 数据导出 statisticsLoad
export function handleStatisticsLoad(params) {
  return request.get(api.schoolbase.statisticsLoad, params);
}

export function getDocumentRecommend(params) {
  return request.get(api.document.getDocumentRecommend, params);
}
export function getDocumentLhsRecommendList(params) {
  return request.get(api.document.getDocumentLhsRecommendList, params);
}
export function getDocumentAllType(params) {
  return request.get(api.document.documentAllType, params);
}
export function getResourceRecommendCard(params) {
  return request.get(api.work.getResourceRecommendCard, params);
}
// 获取指定地区课程下的教材主次版本
export function getTextBookVersionByCourseIdAndAreaId(params) {
  return request.get(api.base.getTextBookVersionByCourseIdAndAreaId, params);
}
// 获取指定课程下面的备课文件夹
export function getBkFolderList(params) {
  return request.get(api.base.getBkFolderList, params);
}
export function getUserFolderLastSelected(params) {
  return request.get(api.work.getUserFolderLastSelected, params);
}
// 获取教学日历
export function getTeachResourceList(params) {
  return request.get(api.work.getTeachResourceList, params);
}
// 获取我的权益信息

export function getUserEquity(params) {
  return request.get(api.work.getUserEquity, params);
}

// 获取用户数据看板
export function getUserData(params) {
  return request.get(api.work.getUserData, params);
}
// 获取集备待办列表
export function getUserCollectiveTasks(params) {
  return request.get(api.work.getUserCollectiveTasks, params);
}

export function putHmktUsageLog(params) {
  return request.get(api.work.putHmktUsageLog, params);
}

export function getUserRights() {
  return request.get(api.rights.getUserRights);
}

export function getSchoolBaseTabs() {
  return request.get(api.schoolbase.tabs);
}

export function getSyncTeachMenus(params) {
  return request.postJson(api.sync.syncTeachMenus, params);
}
// 推荐栏目资料列表
export function getRecommendCategoryList(params) {
  return request.postJson(api.sync.getRecommendCategoryList, params);
}
export function getTeachDocumentList(params) {
  return request.postJson(api.exam.getTeachDocumentList, params);
}
export function getCategoryDocumentList(params) {
  return request.postJson(api.sync.getCategoryDocumentList, params);
}
export function getResourceCategoriesLHS(params) {
  return request.get(api.nav.resourceCategoriesLHS, params);
}
// 云资源整体优化--Tab页筛选条件
export function getNavFilterTabs(params) {
  return request.get(api.nav.navFilterTabs, params);
}

export function getTestPaperCatalogV4(params) {
  return request.get(api.nav.testPaperCatalogV4, params);
}

export function getSubjectSpecialCatalogV4(params) {
  return request.get(api.nav.subjectSpecialCatalogV4, params);
}
export function getChildResourceList(params) {
  return request.postJson(api.sync.getChildResourceList, params);
}

export function getRecommendResourceList(params) {
  return request.get(api.sync.getRecommendResourceList, params);
}

export function getExamDocumentRecommendList(params) {
  return request.get(api.exam.getDocumentRecommendList, params);
}

export function getSyncYearRange() {
  return request.get(api.sync.syncYearRange);
}

export function getSyncUrl(params) {
  return request.postJson(api.nav.getSyncUrl, params);
}

export function getTechUrl(params) {
  return request.postJson(api.nav.getTechUrl, params);
}
// 资源下载科目数量对比
export function getSubjectDownload(params) {
  return request.post(api.schoolData.getSubjectDownload, params, ISJSON);
}
// 资源下载使用类型对比
export function getTypeDownload(params) {
  return request.post(api.schoolData.getTypeDownload, params, ISJSON);
}
// 教师备课详情-备课文件科目对比
export function getLectureFileData(params) {
  return request.post(api.schoolData.getLectureFileData, params, ISJSON);
}
// 教师备课详情-集备任务科目对比
export function getLectureTaskData(params) {
  return request.post(api.schoolData.getLectureTaskData, params, ISJSON);
}
// 校本上传科目对比
export function getSchoolUploadData(params) {
  return request.post(api.schoolData.getSchoolUploadData, params, ISJSON);
}
// 获取教学动态数据
export function getTeachingData(params) {
  return request.post(api.schoolData.getTeachingData, params, ISJSON);
}
// 获取学校指标数据
export function getMetricData(params) {
  return request.post(api.schoolData.getMetricData, params, ISJSON);
}
// 是否有权限学校
export function getSchoolAuth() {
  return request.get(api.schoolData.getSchoolAuth);
}
export function getYxPreview(params) {
  return request.get(api.document.yxPreview, params);
}
export function getYxVideoUrl(params) {
  return request.get(api.document.yxVideoUrl, params);
}
export function findWordIdDetail(params) {
  return request.get(api.endict.wordIdDetail, params);
}

export function findWordNameDetail(params) {
  return request.get(api.endict.wordNameDetail, params);
}

export function findWordSearch(params) {
  return request.get(api.endict.wordSearch, params);
}

export function getCatalogWordList(params) {
  return request.postJson(api.endict.catalogWordList, params);
}
export function getMaterialNodeKnowledgeDocumentList(params) {
  return request.get(api.document.getMaterialNodeKnowledgeDocumentList, params);
}
// 获取校本资源中，搜索下拉筛选项
export function getFilteredOptions() {
  return request.postJson(api.schoolbase.getFilteredOptions);
}
// 获取学校后台配置各功能状态
export function getSchoolConfigStatus() {
  return request.get(api.schoolbase.getSchoolConfigStatus);
}

export function getAlbumInfo(params) {
  return request.get(api.album.info, params);
}
export function getAlbumInfoRecommendAlbumList(params) {
  return request.postJson(api.album.albumInfoRecommendAlbumList, params);
}
export function addDocumentPv(params) {
  return request.get(api.document.addDocumentPv, params);
}

export function savePlayLoglabDatakanban(params) {
  return request.postJson(api.labDatakanban.savePlayLog, params);
}

export function getLabUseDatakanban(params) {
  return request.postJson(api.labDatakanban.getLabUseDatakanban, params);
}

export function getLabUseDataInfo(params) {
  return request.postJson(api.labDatakanban.getLabUseDataInfo, params);
}

export function exportPlayLog(params) {
  return request.downLoadBuffer(
    api.labDatakanban.exportPlayLog,
    params,
    "POST"
  );
}

export function saveVisitDurationLog(params) {
  return request.postJson(api.labDatakanban.saveVisitDurationLog, params);
}

export function syncTextbooks(params) {
  return request.get(api.base.syncTextbooks, params);
}

export function getLabVisitDurationDatakanban(params) {
  return request.postJson(
    api.labDatakanban.getLabVisitDurationDatakanban,
    params
  );
}

export function getLabVisitDurationDetailList(params) {
  return request.postJson(
    api.labDatakanban.getLabVisitDurationDetailList,
    params
  );
}
export function getZykDocumentList(params) {
  return request.get(api.zyk.documentList, params);
}
export function getZykFiltersAndTree(params) {
  return request.get(api.zyk.filtersAndTree, params);
}
export function getZykGlobalPages(params) {
  return request.get(api.zyk.globalPages, params);
}
export function exportVisitLog(params) {
  return request.downLoadBuffer(
    api.labDatakanban.exportVisitLog,
    params,
    "POST"
  );
}
export function getUserModuleAuth() {
  return request.get(api.work.getUserModuleAuth);
}

export function getPayInfo(params) {
  return request.postJson(api.settle.getPayInfo, params);
}

export function documentSettle(params) {
  return request.postJson(api.settle.documentSettle, params);
}

export function getAiSciencePageLayout() {
  return request.get(api.aikx.aiSciencePageLayout);
}
export function getAiKxDocumentList(params) {
  return request.get(api.aikx.documentList, params);
}
export function getStageSubjectList() {
  return request.get(api.airead.getStageSubjectList);
}
export function getGradeList(params) {
  return request.get(api.airead.getGradeList, params);
}
export function getCatalogList(params) {
  return request.get(api.airead.getCatalogList, params);
}
export function getCategoryList(params) {
  return request.get(api.airead.getCategoryList, params);
}
export function getUserUsedCourse() {
  return request.get(api.airead.getUserUsedCourse);
}

export function updateOrAddUsedCourse(params) {
  return request.postJson(api.airead.updateOrAddUsedCourse, params);
}
export function getAiReadDocumentList(params) {
  return request.postJson(api.airead.documentList, params);
}

export function getAiReadAlbumInfo(params) {
  return request.get(api.airead.getAlbumInfo, params);
}
export function getAiKxDocumentRecommendList(params) {
  return request.get(api.aikx.documentRecommendList, params);
}
export function getDocumentPreview(params) {
  return request.get(api.document.preview, params);
}

export function getAiReadDocumentRecommendList(params) {
  return request.get(api.airead.getRecommendList, params);
}
//创建仿真实验室临时链接
export function getLabTempLink(params) {
  return request.postJson(api.document.labTempLink, params);
}

//根据仿真实验室临时链接获取预览信息
export function getLabPrueViewInfo(params) {
  return request.get(api.document.labPrueViewInfo, params);
}

export function getAlbumPayInfo(params) {
  return request.get(api.settle.getAlbumPayInfo, params);
}
export function getAlbumSettle(params) {
  return request.postJson(api.settle.albumSettle, params);
}
export function getDocumentPayInfo(params) {
  return request.postJson(api.settle.getDocumentPayInfo, params);
}
export function getAlbumDownLoadUrl(params) {
  return request.postJson(api.document.getAlbumDownLoadUrl, params);
}
export function updateUserFunctionSort(params) {
  return request.postJson(api.work.updateUserFunctionSort, params);
}
export function getCourseList(params) {
  return request.get(api.basic.getCourseList, params);
}
export function getLastUsedCourse(params) {
  return request.get(api.basic.getLastUsedCourse, params);
}
export function updateLastUsedCourse(params) {
  return request.postJson(api.basic.updateLastUsedCourse, params);
}

export function getWeekTeachingCalendar(params) {
  return request.get(api.work.getWeekTeachingCalendar, params);
}
export const getWeekSignInfo = () => {
  return request.get(
    `${window.location.origin}/zxxk/api-user/task/user-week-sign-info`
  );
};
// 上好课获取同步/备考的tab 状态
export function getSyncTabsStatus(params) {
  return request.get(api.sync.syncTabsStatus, params);
}

//添加意见反馈到rbm
export function putUserQuestion(params) {
  return request.post(api.feedback.putUserQuestion, params);
}
////分页获取提交到RBM处的挑错建议
export function getResourceQuestionList(params) {
  return request.get(api.feedback.getResourceQuestionList, params);
}
export function getLocalSchoolList(params) {
  return request.get(api.school.getLocalSchoolList, params);
}
export function getSchoolFollowList(params) {
  return request.postJson(api.school.getSchoolFollowList, params);
}
export function getSchoolDetail(params) {
  return request.get(api.school.getSchoolDetail, params);
}
export function addSchoolFollow(params) {
  return request.post(api.school.addSchoolFollow, params);
}
export function cancelSchoolFollow(params) {
  return request.post(api.school.cancelSchoolFollow, params);
}
export function getSchoolList(params) {
  return request.get(api.school.getSchoolList, params);
}
export function getGradeAndTermList(params) {
  return request.get(api.zyk.getGradeAndTermList, params);
}
export function getAreaList(params) {
  return request.get(api.zyk.getAreaList, params);
}
export function updateLastUsedGradeAndTerm(params) {
  return request.postJson(api.zyk.updateLastUsedGradeAndTerm, params);
}
